import React from 'react';
import { Form } from 'react-bootstrap';

const EmailShareForm = ({
  email = '',
  onEmailChange,
  expiryOption = 'never',
  onExpiryOptionChange
}) => {
  return (
    <Form>
      {/* Email Input */}
      <Form.Group className="mb-3">
        <Form.Label className="text-label">
          Email Address <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter email address"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          required
        />
        <small className="form-text text-muted">
          Enter the email address to share the document with
        </small>
      </Form.Group>

      {/* Expiry Option */}
      <Form.Group className="mb-3">
        <Form.Label className="text-label">
          Expiry Option
        </Form.Label>
        <Form.Select
          value={expiryOption}
          onChange={(e) => onExpiryOptionChange(e.target.value)}
        >
          <option value="1day">1 Day</option>
          <option value="1week">1 Week</option>
          <option value="1month">1 Month</option>
          <option value="never">Never</option>
        </Form.Select>
        <small className="form-text text-muted">
          Select when the shared link should expire
        </small>
      </Form.Group>
    </Form>
  );
};

export default EmailShareForm;
